export default __webpack_public_path__ + "static/media/fpa61000.6e184c58.png";